/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react'
import ReactDOM from 'react-dom'
import Wrapper from '../lib/wrapper'
import Login from './login'

ReactDOM.render(
  <Wrapper>
    <Login />
  </Wrapper>,
  document.getElementById('root'),
)
